import * as React from "react";
import styled from 'styled-components';
import { getColor, getFontSize} from '@process-advisor/process-miner/shared/theme';
import { WorkFlowAnalysis} from '@process-advisor/process-miner/workflows/workFlowAnalysis'
import { apiProvider } from "@process-advisor/process-miner/api/apiProvider";
import { Event } from '@process-advisor/process-miner/api/events'

const Wrapper = styled.div`
    display: grid;
    width: 100%;
    background-color: ${getColor('lightestGray')};
    padding-top: 15px;
    padding-left: 30px;
    padding-right: 30px;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-column-gap: 25px;
    column-gap: 25px;
`;

type Props  = {
    AppVersion?: string,
    contextPath?: any
}

export const WorkFlow: React.FC<Props> = ({AppVersion,contextPath}) => {

    React.useEffect(() => {
        const listener = () => {
            //updateContent()
        };
        listener();

        apiProvider.on(Event.setActionBar_Workflow, listener);

        return () => {
            apiProvider.off(Event.setActionBar_Workflow, listener);
        };
    }, []);

    return (
        <div>
        <Wrapper>   
            <WorkFlowAnalysis AppVersion={AppVersion} contextPath={contextPath}/>
        </Wrapper>
        </div>
    );
};

